/**
 * nordura-cart-bubble.js
 * Keeps the header cart-count bubble in sync after AJAX add-to-cart, without
 * a full page reload. Listens for the `cart:refresh` event dispatched by
 * nordura-product-form.js.
 */
(function () {
  'use strict';

  document.addEventListener('cart:refresh', function () {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-n-cart-bubble]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () { /* non-fatal: bubble simply won't update this time */ });
  });
})();
